<template>
  <v-dialog v-model="isActiveModal" width="450">
    <v-card>
      <v-toolbar dense color="primary" :dark="true">
        <v-toolbar-title>Ayuda</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid class="d-flex flex-column PaddingDivFilter">
        <v-row justify="center">
          <v-col class="m-1">
            <div>
              <p style="text-align: justify;">
                El <strong>etiquetado</strong> es un sistema de representación
                que utiliza terminos o expresion para identificar de forma
                optima contenido informativo. Las etiquetas seran entonces
                terminos que representen un audio.
              </p>
              <strong> Ejemplo: <br /></strong>

              {ciudad}_{folio}_{status}_{@date:yyyy-MM-dd}.mp3 <br />
              El resultado final sera el siguiente:
              <strong>bogota_999291_VENTA_2020-12-08.mp3<br /></strong>
              <br />
              <small
                >Nota: El carácter dos puntos ":" es exclusivo para
                {@date:yyyy-MM-dd}, por favor no utilizarlo en otra parte del
                formato.</small
              >
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isActiveModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({}),
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
  watch: {},
};
</script>

<style>
.PaddingDivFilter {
  padding-bottom: 2rem !important;
}
</style>
